export function createKeyboardNavigationHandler<T>(
  showSuggestions: boolean,
  suggestions: T[],
  isExpanded: boolean,
  selectedIndex: number,
  setSelectedIndex: (index: number) => void,
  setIsExpanded: (expanded: boolean) => void,
  onSuggestionClick: (suggestion: T) => void
) {
  return (e: React.KeyboardEvent) => {
    if (!showSuggestions || suggestions.length === 0) return

    const maxIndex = isExpanded ? suggestions.length - 1 : 0

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault()
        if (selectedIndex < maxIndex) {
          setSelectedIndex(selectedIndex + 1)
        } else if (!isExpanded && suggestions.length > 1) {
          setIsExpanded(true)
          setSelectedIndex(1)
        }
        break
      case 'ArrowUp':
        e.preventDefault()
        setSelectedIndex(selectedIndex > 0 ? selectedIndex - 1 : -1)
        break
      case 'Enter':
        e.preventDefault()
        if (selectedIndex >= 0 && selectedIndex < suggestions.length) {
          onSuggestionClick(suggestions[selectedIndex])
        }
        break
    }
  }
}
